(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-detail-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const mounted = new WeakMap();
  const normalize = value => String(value ?? '').trim().toLocaleLowerCase();
  function initializeInformation(section, on, mediaQuery) {
    const group = section.querySelector('[data-product-information-group]');
    if (!group) return () => {};
    const nav = group.querySelector('[data-information-tabs]');
    const panels = [...group.querySelectorAll('[data-information-panel]')].map(element => ({
      element, name: element.dataset.informationPanel,
      summary: element.querySelector(':scope > summary'),
      body: element.querySelector('[data-information-body]'),
      mobileOpen: element.dataset.mobileOpen === 'true'
    }));
    let selected = panels[0];
    let wasMobile;
    let hasReviews = false;
    const review = panels.find(panel => panel.name === 'reviews');
    const eligible = panel => Boolean(panel && (panel !== review || hasReviews));
    const descriptionPanel = panels.find(panel => panel.name === 'description');
    const description = descriptionPanel?.body.querySelector('.product-detail-content__description');
    const more = descriptionPanel?.body.querySelector('[data-description-more]');
    const closeDescription = descriptionPanel?.body.querySelector('[data-description-close]');
    let descriptionExpanded = false;
    function contentBlocks(container) {
      return [...container.children].flatMap(node => {
        if (node.hidden) return [];
        if (node.matches('div, section, p') && !node.textContent.trim() && node.querySelector('img') && !node.querySelector('video, iframe, form, table')) return contentBlocks(node);
        return [node];
      });
    }
    const blocks = description ? contentBlocks(description) : [];
    const meaningfulBlocks = blocks.filter(node => node.textContent.trim() || node.matches('img, picture, video, iframe, hr') || node.querySelector('img, video, iframe'));
    const previewImages = Math.min(6, Math.max(1, Math.floor(Number(description?.dataset.previewImages) || 1)));
    const previewTextLimit = Math.min(1800, Math.max(300, Number(description?.dataset.previewTextLimit) || 900));
    const imageBlocks = meaningfulBlocks.filter(node => node.matches('img, picture') || node.querySelector('img'));
    let previewEnd = imageBlocks[Math.min(previewImages, imageBlocks.length) - 1] || meaningfulBlocks[0];
    if (previewEnd?.matches('h1,h2,h3,h4,h5,h6')) previewEnd = meaningfulBlocks[1] || previewEnd;
    const canPreview = description && description.dataset.mobilePreview !== 'false' && meaningfulBlocks.length > 1 && (imageBlocks.length > previewImages || description.textContent.trim().length > previewTextLimit);
    const deferred = canPreview ? blocks.slice(blocks.indexOf(previewEnd) + 1) : [];
    const restoreDescription = () => deferred.forEach(node => { node.removeAttribute('hidden'); node.removeAttribute('data-description-deferred'); });
    function renderDescription() {
      const folded = mediaQuery.matches && !descriptionExpanded && deferred.length > 0;
      if (folded) deferred.forEach(node => { node.hidden = true; node.setAttribute('data-description-deferred', ''); });
      else restoreDescription();
      if (more) { more.hidden = !folded; more.setAttribute('aria-expanded', String(!folded)); }
      if (closeDescription) closeDescription.hidden = !mediaQuery.matches;
    }
    on(more, 'click', () => {
      descriptionExpanded = true; renderDescription(); description.focus({ preventScroll: true });
    });
    on(closeDescription, 'click', () => {
      descriptionPanel.element.open = false;
      descriptionPanel.mobileOpen = false;
      descriptionExpanded = false; renderDescription();
      descriptionPanel.summary.focus({ preventScroll: true });
      descriptionPanel.summary.scrollIntoView({ block: 'start', behavior: 'instant' });
    });
    on(descriptionPanel?.element, 'toggle', () => {
      if (mediaQuery.matches && !descriptionPanel.element.open) { descriptionExpanded = false; renderDescription(); }
    });
    nav.setAttribute('role', 'tablist');
    nav.replaceChildren();
    panels.forEach(panel => {
      const button = document.createElement('button');
      button.type = 'button';
      button.id = panel.summary.id + '-tab';
      button.dataset.panel = panel.name;
      button.textContent = panel.summary.querySelector('span').textContent;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panel.body.id);
      nav.append(button);
      panel.button = button;
      on(button, 'click', () => { selected = panel; render(); });
      on(button, 'keydown', event => {
        const available = panels.filter(eligible);
        const index = available.indexOf(panel);
        let next;
        if (event.key === 'ArrowRight') next = available[(index + 1) % available.length];
        if (event.key === 'ArrowLeft') next = available[(index - 1 + available.length) % available.length];
        if (event.key === 'Home') next = available[0];
        if (event.key === 'End') next = available[available.length - 1];
        if (!next) return;
        event.preventDefault(); selected = next; render(); next.button.focus();
      });
    });
    function render() {
      if (wasMobile) panels.filter(panel => !panel.element.classList.contains('pdp-information__panel--fallback')).forEach(panel => { panel.mobileOpen = panel.element.open; });
      const mobile = mediaQuery.matches;
      if (!eligible(selected)) selected = panels.find(eligible);
      nav.hidden = mobile || !panels.some(eligible);
      group.dataset.informationMode = mobile ? 'accordion' : 'tabs';
      panels.forEach(panel => {
        const available = eligible(panel);
        const active = panel === selected;
        const focused = panel.element.contains(document.activeElement) || panel.button === document.activeElement;
        panel.button.hidden = !available;
        panel.button.tabIndex = active && available ? 0 : -1;
        panel.button.setAttribute('aria-selected', String(active && available));
        panel.element.hidden = !mobile && available && !active;
        panel.element.open = !available || !mobile || panel.mobileOpen;
        panel.summary.hidden = !mobile || !available;
        panel.element.classList.toggle('pdp-information__panel--fallback', !available);
        if (!mobile && available) {
          panel.body.setAttribute('role', 'tabpanel');
          panel.body.setAttribute('aria-labelledby', panel.button.id);
          panel.body.tabIndex = 0;
        } else {
          panel.body.removeAttribute('role');
          panel.body.removeAttribute('aria-labelledby');
          panel.body.removeAttribute('tabindex');
        }
        if (focused && wasMobile !== mobile && available) {
          if (mobile) { panel.element.open = true; panel.summary.focus({ preventScroll: true }); }
          else if (panel.element.hidden || document.activeElement === panel.summary) selected?.button.focus({ preventScroll: true });
        }
      });
      wasMobile = mobile;
      renderDescription();
    }
    function reveal(target) {
      const panel = panels.find(panel => panel.element.contains(target));
      if (!panel) return;
      if (eligible(panel)) selected = panel;
      if (panel === descriptionPanel && deferred.some(node => node === target || node.contains(target))) descriptionExpanded = true;
      render();
      panel.element.open = true;
    }
    const revealHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (target && group.contains(target)) { reveal(target); target.scrollIntoView({ block: 'start' }); }
    };
    on(section, 'click', event => {
      const link = event.target.closest('a[href]');
      if (!link || !link.hash || link.origin !== location.origin || link.pathname !== location.pathname || link.search !== location.search) return;
      let id;
      try { id = decodeURIComponent(link.hash.slice(1)); } catch { return; }
      reveal(document.getElementById(id));
    }, { capture: true });
    on(window, 'hashchange', revealHash);
    on(section, 'shopify:block:select', event => reveal(event.target));
    on(mediaQuery, 'change', render);
    const updateReviews = () => {
      const count = review?.body.querySelector('.jdgm-rev-widg[data-number-of-reviews], .jdgm-prev-badge[data-number-of-reviews]')?.getAttribute('data-number-of-reviews');
      const next = !window.Shopify?.designMode && /^\d+$/.test(count || '') && Number(count) > 0;
      if (next === hasReviews) return;
      hasReviews = next;
      if (next && review.element.contains(document.activeElement)) selected = review;
      const returnFocus = review.button === document.activeElement;
      render();
      if (returnFocus && !next) selected?.button.focus({ preventScroll: true });
    };
    const reviewObserver = new MutationObserver(updateReviews);
    if (review) reviewObserver.observe(review.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
    render(); updateReviews(); revealHash();
    return () => {
      restoreDescription();
      if (more) more.hidden = true;
      if (closeDescription) closeDescription.hidden = true;
      reviewObserver.disconnect(); nav.replaceChildren(); nav.hidden = true;
      delete group.dataset.informationMode;
      panels.forEach(panel => {
        panel.element.hidden = false; panel.element.open = panel.mobileOpen;
        panel.summary.hidden = false; panel.element.classList.remove('pdp-information__panel--fallback');
        panel.body.removeAttribute('role'); panel.body.removeAttribute('aria-labelledby'); panel.body.removeAttribute('tabindex');
      });
    };
  }
  function initialize(section) {
    if (mounted.has(section)) return;
    const form = section.querySelector('[data-product-form]');
    if (!form) return;
    const abort = new AbortController();
    const { signal } = abort;
    const on = (node, event, callback, options = {}) => node?.addEventListener(event, callback, { ...options, signal });
    const find = selector => section.querySelector(selector);
    const all = selector => [...section.querySelectorAll(selector)];
    all('.product-detail-content__description img:not([alt])').forEach(image => image.setAttribute('alt', ''));
    const readJSON = selector => {
      try { return JSON.parse(find(selector)?.textContent || '[]'); } catch { return []; }
    };
    const variants = readJSON('[data-product-variants]');
    if (!variants.length) return;
    const mappings = readJSON('[data-color-mappings]');
    const variantInput = find('[data-variant-id]');
    const quantityInput = find('[data-quantity-input]');
    const rows = all('[data-option-index]');
    const colorRow = find('[data-color-option]');
    const sizeRow = find('[data-size-option]');
    const mainActions = find('[data-main-actions]');
    const cartButton = form.querySelector('button[name="add"]');
    const buyButton = find('[data-buy-now]');
    const sticky = find('[data-sticky-cart]');
    const stickyButton = find('[data-sticky-submit]');
    const formMessage = find('[data-product-form-message]');
    const totalWrap = find('[data-product-total-wrap]');
    const labels = all('[data-cart-label]');
    const defaultLabel = labels[0]?.textContent || '';
    const unavailable = section.dataset.unavailableMessage;
    const selectMessage = section.dataset.selectMessage;
    const quantityError = section.dataset.quantityError;
    const moneyCurrency = totalWrap?.dataset.moneyCurrency || 'JPY';
    const moneyLocale = totalWrap?.dataset.moneyLocale || document.documentElement.lang;
    const money = cents => new Intl.NumberFormat(moneyLocale, {
      style: 'currency', currency: moneyCurrency
    }).format(Number(cents) / 100);
    const mediaQuery = window.matchMedia('(max-width: 900px)');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cleanupInformation = initializeInformation(section, on, mediaQuery);
    let variant;
    let submitting = false;
    let previousVariantId;
    let selectedMediaId;
    let activeGalleryIndex = 0;
    let mainVisible = true;
    let galleryTimer;
    let scrollFrame;
    let pointer;
    const viewport = find('[data-gallery-viewport]');
    const gallery = find('[data-product-gallery]');
    const slides = all('[data-gallery-slide]');
    const thumbs = all('[data-gallery-thumb]');
    let autoplayPaused = false;
    let observer;
    let resizeObserver;
    let modalObserver;
    const checked = row => row?.querySelector('[data-option-value]:checked');
    const values = () => {
      const options = [];
      rows.forEach(row => { options[Number(row.dataset.optionIndex)] = checked(row)?.value ?? null; });
      return options;
    };
    const match = (candidate, options) => candidate.options.every((value, index) => value === options[index]);
    const rule = () => ({
      min: Math.max(1, Number(variant?.quantity_rule?.min) || 1),
      max: variant?.quantity_rule?.max == null ? Infinity : Number(variant.quantity_rule.max),
      step: Math.max(1, Number(variant?.quantity_rule?.increment) || 1)
    });
    const quantity = () => Number(quantityInput.value);
    function validQuantity() {
      const { min, max, step } = rule();
      const number = quantity();
      return Number.isSafeInteger(number) && number >= min && number <= max && (number - min) % step === 0;
    }
    const addons = () => all('[data-addon-select]').filter(select => select.value).map(select => ({
      id: Number(select.value), quantity: 1, price: Number(select.selectedOptions[0]?.dataset.addonPrice) || 0
    }));
    const cartItems = () => [{ id: Number(variant.id), quantity: quantity() }, ...addons().map(({ id, quantity }) => ({ id, quantity }))];
    const setText = (selector, text) => all(selector).forEach(node => { node.textContent = text; });
    function message(text) {
      if (!formMessage) return;
      formMessage.textContent = text || '';
      formMessage.hidden = !text;
    }
    function galleryState(index) {
      if (!slides.length) return;
      activeGalleryIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === activeGalleryIndex)));
      setText('[data-gallery-counter]', (activeGalleryIndex + 1) + ' / ' + slides.length);
      const zoom = find('[data-gallery-zoom]');
      if (zoom) zoom.hidden = slides[activeGalleryIndex].dataset.mediaType !== 'image';
      slides.forEach((slide, i) => {
        if (i !== activeGalleryIndex) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    }
    function goToImage(index, smooth = true) {
      if (!viewport || !slides.length) return;
      galleryState((index + slides.length) % slides.length);
      viewport.scrollTo({ left: activeGalleryIndex * viewport.clientWidth, behavior: smooth && !motionQuery.matches ? 'smooth' : 'instant' });
      const thumb = thumbs[activeGalleryIndex];
      if (thumb) {
        const strip = thumb.parentElement;
        if (mediaQuery.matches) strip.scrollTo({ left: Math.max(0, thumb.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'instant' });
        else strip.scrollTo({ top: Math.max(0, thumb.offsetTop - strip.offsetTop - strip.clientHeight / 2 + thumb.clientHeight / 2), behavior: 'instant' });
      }
    }
    const stopAutoplay = () => { clearInterval(galleryTimer); galleryTimer = undefined; };
    function startAutoplay() {
      stopAutoplay();
      if (gallery?.dataset.galleryAutoplay !== 'true' || autoplayPaused || motionQuery.matches || document.hidden || slides.length < 2) return;
      galleryTimer = setInterval(() => {
        if (!gallery.contains(document.activeElement) && !document.querySelector('dialog[open]')) goToImage(activeGalleryIndex + 1);
      }, Math.max(3000, Number(gallery.dataset.galleryAutoplayDelay) || 5000));
    }
    function mappedSlide(color) {
      const mapping = mappings.find(item => normalize(item.color) === normalize(color));
      if (!mapping) return undefined;
      return slides.find(slide => slide.dataset.mediaId === String(mapping.media_id));
    }
    function updateVariantMedia() {
      const color = checked(colorRow)?.value;
      const nativeSlide = slides.find(slide => variant?.media_id != null && slide.dataset.mediaId === String(variant.media_id));
      const target = nativeSlide || mappedSlide(color);
      const newKey = target?.dataset.mediaId || null;
      if (newKey !== selectedMediaId) {
        selectedMediaId = newKey;
        goToImage(target ? slides.indexOf(target) : 0, false);
      }
      const source = (target || slides[0])?.querySelector('img');
      const stickyImage = find('[data-sticky-image]');
      if (source && stickyImage) {
        stickyImage.src = source.currentSrc || source.src;
        stickyImage.removeAttribute('srcset');
      }
    }
    function updateSticky() {
      if (!sticky) return;
      const focused = document.activeElement;
      const typing = focused?.matches('input:not([type=radio]):not([type=checkbox]):not([type=hidden]), textarea, [contenteditable=true]');
      const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.72;
      const hasModal = Boolean(document.querySelector('dialog[open]')) || [...document.querySelectorAll('[aria-modal="true"]:not([aria-hidden="true"])')].some(node => node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden');
      const hidden = Boolean(!mediaQuery.matches || mainVisible || typing || keyboard || hasModal);
      if (sticky.hidden !== hidden) sticky.hidden = hidden;
    }
    function scrollToOptions() {
      const target = colorRow || rows[0] || quantityInput;
      target?.scrollIntoView({ behavior: motionQuery.matches ? 'instant' : 'smooth', block: 'center' });
      (checked(target) || target?.querySelector('input') || quantityInput)?.focus({ preventScroll: true });
    }
    function updatePurchaseState() {
      const options = values();
      variant = rows.length ? variants.find(item => match(item, options)) : variants.find(item => String(item.id) === variantInput.value) || variants[0];
      variantInput.value = variant ? String(variant.id) : '';
      const newVariant = variant?.id !== previousVariantId;
      previousVariantId = variant?.id;
      const { min, max, step } = rule();
      quantityInput.min = String(min);
      quantityInput.step = String(step);
      if (Number.isFinite(max)) quantityInput.max = String(max); else quantityInput.removeAttribute('max');
      if (newVariant && !validQuantity()) quantityInput.value = String(min);
      const valid = validQuantity();
      quantityInput.setCustomValidity(valid ? '' : quantityError);
      quantityInput.setAttribute('aria-invalid', String(!valid));
      const available = Boolean(variant?.available && valid);
      [cartButton, buyButton].forEach(button => {
        if (button) { button.disabled = !available || submitting; button.setAttribute('aria-busy', String(submitting)); }
      });
      if (stickyButton) {
        stickyButton.disabled = submitting || Boolean(variant && !variant.available);
        stickyButton.setAttribute('aria-busy', String(submitting));
      }
      labels.forEach(label => { label.textContent = submitting ? section.dataset.loadingMessage : (!variant ? selectMessage : !variant.available ? unavailable : defaultLabel); });
      find('[data-quantity-minus]').disabled = submitting || !valid || quantity() <= min;
      find('[data-quantity-plus]').disabled = submitting || !valid || quantity() + step > max;
      rows.forEach(row => {
        const selected = checked(row);
        row.querySelector('[data-selected-option]').textContent = selected?.value || '';
        row.querySelectorAll('[data-option-value]').forEach(input => {
          const proposed = options.slice();
          proposed[Number(row.dataset.optionIndex)] = input.value;
          const canBuy = variants.some(candidate => candidate.available && match(candidate, proposed));
          input.nextElementSibling.classList.toggle('is-unavailable', !canBuy);
          input.nextElementSibling.querySelector('[data-option-status]').textContent = canBuy ? '' : ' — ' + unavailable;
        });
      });
      setText('[data-variant-price]', variant ? money(variant.price) : '—');
      const compare = find('[data-variant-compare]');
      if (compare) {
        compare.hidden = !variant || !(variant.compare_at_price > variant.price);
        compare.textContent = compare.hidden ? '' : money(variant.compare_at_price);
      }
      const extra = addons();
      const subtotal = variant && valid ? variant.price * quantity() + extra.reduce((sum, item) => sum + item.price * item.quantity, 0) : null;
      const count = quantity() + extra.reduce((sum, item) => sum + item.quantity, 0);
      setText('[data-product-total]', subtotal == null ? '—' : money(subtotal) + ' (' + (totalWrap.dataset.totalCountTemplate || '__count__').replace('__count__', count) + ')');
      setText('[data-sticky-price]', subtotal == null ? '—' : money(subtotal));
      const summary = rows.length ? [checked(colorRow)?.value, checked(sizeRow)?.value, ...rows.filter(row => row !== colorRow && row !== sizeRow).map(row => checked(row)?.value)].filter(Boolean).join(' / ') : section.querySelector('h1').textContent;
      setText('[data-sticky-summary]', summary + (valid && quantity() > 1 ? ' × ' + quantity() : ''));
      all('[data-size-row]').forEach(row => row.classList.toggle('is-selected', row.dataset.sizeRow === checked(sizeRow)?.value));
      all('[data-size-summary]').forEach(summary => {
        const measurements = [...summary.querySelectorAll('[data-size-summary-row]')];
        measurements.forEach(row => { row.hidden = row.dataset.sizeSummaryRow !== checked(sizeRow)?.value; });
        summary.hidden = !measurements.some(row => !row.hidden);
      });
      message(!variant ? selectMessage : !variant.available ? unavailable : !valid ? quantityError : '');
      updateVariantMedia();
      updateSticky();
      return available;
    }
    function updateURL() {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
      window.history.replaceState({}, '', url);
    }
    function selectVariant(id) {
      const target = variants.find(item => String(item.id) === String(id));
      if (!target) return;
      variantInput.value = String(target.id);
      rows.forEach(row => row.querySelectorAll('input').forEach(input => { input.checked = input.value === target.options[Number(row.dataset.optionIndex)]; }));
    }
    on(form, 'change', event => {
      if (event.target === variantInput) selectVariant(variantInput.value);
      if (event.target.matches('[data-option-value], [data-addon-select], [data-variant-id]')) {
        updatePurchaseState();
        updateURL();
        stopAutoplay();
      }
    });
    on(quantityInput, 'input', updatePurchaseState);
    on(find('[data-quantity-minus]'), 'click', () => { quantityInput.value = String(quantity() - rule().step); updatePurchaseState(); });
    on(find('[data-quantity-plus]'), 'click', () => { quantityInput.value = String(quantity() + rule().step); updatePurchaseState(); });
    on(find('[data-addon-toggle]'), 'click', event => {
      const toggle = event.currentTarget;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.closest('.product-addons').classList.toggle('is-collapsed', expanded);
    });
    thumbs.forEach(thumb => on(thumb, 'click', () => { stopAutoplay(); goToImage(Number(thumb.dataset.galleryThumb)); }));
    on(find('[data-gallery-prev]'), 'click', () => { stopAutoplay(); goToImage(activeGalleryIndex - 1); });
    on(find('[data-gallery-next]'), 'click', () => { stopAutoplay(); goToImage(activeGalleryIndex + 1); });
    on(viewport, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); stopAutoplay(); goToImage(activeGalleryIndex + (event.key === 'ArrowLeft' ? -1 : 1));
    });
    on(viewport, 'scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => { if (viewport.clientWidth) galleryState(Math.round(viewport.scrollLeft / viewport.clientWidth)); });
    }, { passive: true });
    on(viewport, 'pointerdown', event => {
      stopAutoplay();
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, video, iframe')) return;
      pointer = { id: event.pointerId, x: event.clientX, scroll: viewport.scrollLeft };
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');
    });
    on(viewport, 'pointermove', event => {
      if (!pointer || pointer.id !== event.pointerId) return;
      viewport.scrollLeft = pointer.scroll - (event.clientX - pointer.x);
    });
    const endPointer = () => {
      if (!pointer) return;
      pointer = undefined; viewport.classList.remove('is-dragging');
      goToImage(Math.round(viewport.scrollLeft / viewport.clientWidth));
    };
    on(viewport, 'pointerup', endPointer); on(viewport, 'pointercancel', endPointer);
    on(viewport, 'lostpointercapture', endPointer);
    on(viewport, 'dragstart', event => event.preventDefault());
    on(gallery, 'focusin', stopAutoplay);
    on(find('[data-gallery-pause]'), 'click', event => {
      autoplayPaused = !autoplayPaused;
      event.currentTarget.setAttribute('aria-pressed', String(autoplayPaused));
      startAutoplay();
    });
    const openDialog = (dialog, trigger) => {
      if (!dialog?.showModal) return;
      stopAutoplay();
      dialog._returnFocus = trigger;
      dialog.showModal();
      updateSticky();
    };
    all('[data-dialog-open]').forEach(trigger => on(trigger, 'click', () => openDialog(document.getElementById(trigger.dataset.dialogOpen), trigger)));
    all('[data-policy-open]').forEach(trigger => on(trigger, 'click', event => {
      const details = document.getElementById(trigger.dataset.policyOpen);
      if (!details || !section.contains(details)) return;
      event.preventDefault();
      details.open = true;
      details.scrollIntoView({ behavior: motionQuery.matches ? 'instant' : 'smooth', block: 'start' });
      details.querySelector('summary')?.focus({ preventScroll: true });
    }));
    all('dialog').forEach(dialog => {
      on(dialog, 'close', () => { dialog._returnFocus?.focus({ preventScroll: true }); updateSticky(); });
      on(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.querySelectorAll('[data-dialog-close]').forEach(button => on(button, 'click', () => dialog.close()));
    });
    on(find('[data-gallery-zoom]'), 'click', event => {
      const slide = slides[activeGalleryIndex];
      if (!slide || slide.dataset.mediaType !== 'image') return;
      const image = new Image();
      image.src = slide.dataset.fullImage;
      image.alt = slide.querySelector('img')?.alt || '';
      find('[data-zoom-content]').replaceChildren(image);
      openDialog(find('[data-zoom-dialog]'), event.currentTarget);
    });
    on(find('[data-sticky-options]'), 'click', scrollToOptions);
    on(stickyButton, 'click', () => {
      if (!updatePurchaseState()) { scrollToOptions(); return; }
      form.requestSubmit(cartButton);
    });
    on(form, 'submit', async event => {
      if (submitting) { event.preventDefault(); return; }
      if (!updatePurchaseState()) { event.preventDefault(); quantityInput.reportValidity(); return; }
      submitting = true;
      updatePurchaseState();
      if (!addons().length) return;
      event.preventDefault();
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems() }), signal
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || form.dataset.cartErrorMessage);
        window.location.assign(form.dataset.cartSuccessUrl || '/cart');
      } catch (error) {
        if (signal.aborted) return;
        submitting = false; updatePurchaseState();
        message(error.message || form.dataset.cartErrorMessage);
      }
    });
    on(buyButton, 'click', () => {
      if (submitting || !updatePurchaseState()) return;
      const items = cartItems().map(item => item.id + ':' + item.quantity).join(',');
      submitting = true; updatePurchaseState();
      window.location.assign((form.dataset.cartPermalinkBase || '/cart/') + items + '?checkout');
    });
    function resetPurchase() { submitting = false; updatePurchaseState(); }
    on(window, 'pageshow', resetPurchase);
    on(window, 'popstate', () => { selectVariant(new URL(window.location.href).searchParams.get('variant')); updatePurchaseState(); });
    on(document, 'visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
    on(document, 'focusin', updateSticky);
    on(document, 'focusout', () => queueMicrotask(() => { if (!signal.aborted) updateSticky(); }));
    on(window.visualViewport, 'resize', updateSticky);
    on(mediaQuery, 'change', () => { goToImage(activeGalleryIndex, false); updateSticky(); });
    on(motionQuery, 'change', startAutoplay);
    if (window.IntersectionObserver && mainActions) {
      observer = new IntersectionObserver(entries => { mainVisible = entries[0].isIntersecting; updateSticky(); });
      observer.observe(mainActions);
    } else {
      const checkVisibility = () => {
        const rect = mainActions.getBoundingClientRect();
        mainVisible = rect.top < window.innerHeight && rect.bottom > 0;
        updateSticky();
      };
      on(window, 'scroll', checkVisibility, { passive: true }); checkVisibility();
    }
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        const panel = find('.product-detail__right');
        const height = panel?.getBoundingClientRect().height || 0;
        const header = document.querySelector('#site-header, .site-header');
        const offset = header?.getBoundingClientRect().height || 60;
        section.style.setProperty('--pdp-header-offset', offset + 'px');
        panel?.classList.toggle('pdp-can-stick', height < window.innerHeight - offset - 40);
        if (viewport) viewport.scrollTo({ left: activeGalleryIndex * viewport.clientWidth, behavior: 'instant' });
      });
      if (viewport) resizeObserver.observe(viewport);
      resizeObserver.observe(find('.product-detail__right'));
    }
    modalObserver = new MutationObserver(updateSticky);
    modalObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['open', 'aria-modal', 'aria-hidden', 'hidden', 'class', 'style'] });
    all('[data-gallery-controls]').forEach(node => { node.hidden = false; });
    if (buyButton) buyButton.hidden = false;
    section.classList.add('pdp-ready');
    selectVariant(new URL(window.location.href).searchParams.get('variant') || variantInput.value);
    updatePurchaseState();
    startAutoplay();
    mounted.set(section, () => {
      stopAutoplay(); cancelAnimationFrame(scrollFrame);
      observer?.disconnect(); resizeObserver?.disconnect(); modalObserver?.disconnect();
      abort.abort();
      cleanupInformation();
      all('dialog[open]').forEach(dialog => dialog.close());
      mounted.delete(section); section.classList.remove('pdp-ready');
    });
  }
  const sections = root => [
    ...(root.matches?.('[data-product-detail]') ? [root] : []),
    ...root.querySelectorAll('[data-product-detail]')
  ];
  const mount = root => sections(root).forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => sections(event.target).forEach(section => mounted.get(section)?.()));
})();
  } catch(e) { console.error(e); }
})();

})();
